import { useState } from "react";
import { topicList } from "@/mocks/guaMore";

const accent = ["bg-red-700", "bg-amber-500", "bg-orange-600", "bg-red-600", "bg-orange-500", "bg-amber-600"];

export default function Topics() {
  const [active, setActive] = useState(0);
  const cur = topicList[active];

  return (
    <section id="topic" className="w-full bg-[#f6efe3]">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="grid gap-8 lg:grid-cols-3">
          <div>
            <p className="text-xs font-semibold tracking-[0.2em] text-red-700">瓜田分区</p>
            <h2 className="font-masthead mt-2 text-2xl font-black text-stone-900 md:text-3xl">
              按话题分区，跟进更聚焦
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-stone-500">
              不同领域的热瓜走向差异巨大。选择你感兴趣的话题专区，即可集中查看该方向下全部事件的进展脉络与最新动态。
            </p>
            <div className="mt-5 rounded-xl border border-orange-900/10 bg-white p-5">
              <p className="text-xs font-semibold tracking-wide text-stone-400">当前分区</p>
              <h3 className="font-masthead mt-1 text-xl font-bold text-stone-900">{cur.name}</h3>
              <p className="mt-2 text-sm leading-relaxed text-stone-500">{cur.desc}</p>
              <div className="mt-3 flex flex-wrap items-center gap-3 text-sm">
                <span className="inline-flex items-center gap-1 rounded-full bg-red-50 px-3 py-1 font-medium text-red-700">
                  <i className="ri-fire-line"></i>
                  {cur.read}
                </span>
                <span className="inline-flex items-center gap-1 rounded-full bg-amber-50 px-3 py-1 font-medium text-amber-800">
                  <i className="ri-stack-line"></i>
                  {cur.count}
                </span>
              </div>
            </div>
          </div>

          <div className="grid gap-4 sm:grid-cols-2 lg:col-span-2">
            {topicList.map((t, i) => (
              <button
                key={t.name}
                onClick={() => setActive(i)}
                className={`group flex items-center gap-4 rounded-xl border p-4 text-left transition-colors ${
                  active === i
                    ? "border-red-700 bg-white"
                    : "border-orange-900/10 bg-white hover:border-orange-900/25"
                }`}
              >
                <span
                  className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-lg ${accent[i % accent.length]} text-white`}
                >
                  <i className="ri-record-circle-line text-xl"></i>
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center justify-between">
                    <h3 className="text-base font-bold text-stone-900">{t.name}</h3>
                    {active === i && <i className="ri-checkbox-circle-fill text-red-700"></i>}
                  </div>
                  <p className="mt-1 text-sm text-stone-500">{t.desc}</p>
                  <p className="mt-1.5 text-xs text-stone-400">
                    {t.count} · {t.read}
                  </p>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}